import React, { useEffect, useState } from "react";
import "./Notification.css";
import { MdDelete } from "react-icons/md";
import multipleMarkedIcon from "../../../assets/multiple-marked.png";
import { getAllNotification } from "../../Component/ContextAPI/ApiContext";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { PaginationBtn } from "../../../User/component/ReUseComps/Button";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { Oval } from "react-loader-spinner";
import axios from "axios";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";
import { errorPopup, successPopup } from "../../../Utils/ToasterMessage";

export default function Notification() {
  const [filterBtn, setFilterBtn] = useState({
    all: true,
    newApplication: false,
    jobUpdates: false,
    accountUpdates: false,
  });

  const [allNotifications, setAllNotifications] = useState(null);
  const [paginationBtnArr, setpaginationBtnArr] = useState([1, 2, 3, 4, 5]);
  const [clipArrLength, setClipArrLength] = useState({ min: 0, max: 10 });
  const [activePageNo, setActivePageNo] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [loader, setLoader] = useState(false);
  const [notificationRange, setNotificationRange] = useState({
    page: 1,
    limit: 100,
    status: true,
  });

  const handleFilterBtnChange = (type) => {
    type === "all" &&
      setFilterBtn({
        all: true,
        newApplication: false,
        jobUpdates: false,
        accountUpdates: false,
      });
    type === "newApplication" &&
      setFilterBtn({
        all: false,
        newApplication: true,
        jobUpdates: false,
        accountUpdates: false,
      });
    type === "jobUpdates" &&
      setFilterBtn({
        all: false,
        newApplication: false,
        jobUpdates: true,
        accountUpdates: false,
      });
    type === "accountUpdates" &&
      setFilterBtn({
        all: false,
        newApplication: false,
        jobUpdates: false,
        accountUpdates: true,
      });
  };

  const notifications = [
    {
      title: "New Job Application Steps",
      message: "Stay updated on your applications! Visit the 'Applied Jobs'",
      date: "04 April, 2021",
      time: "04:00 PM",
    },
    {
      title: "Profile Update Reminder",
      message:
        "Your profile is incomplete. Complete it to get better job recommendations.",
      date: "05 April, 2021",
      time: "10:30 AM",
    },
    {
      title: "New Job Posting in Your Field",
      message: "Check out the latest job posting in your preferred category.",
      date: "06 April, 2021",
      time: "02:15 PM",
    },
    {
      title: "Interview Invitation",
      message:
        "You have been invited for an interview. Check your email for details.",
      date: "07 April, 2021",
      time: "09:00 AM",
    },
    {
      title: "Application Status Update",
      message:
        "Your application status has been updated. Visit 'Applied Jobs' for details.",
      date: "08 April, 2021",
      time: "03:45 PM",
    },
    {
      title: "New Job Posting in Your Field",
      message: "Check out the latest job posting in your preferred category.",
      date: "06 April, 2021",
      time: "02:15 PM",
    },
    {
      title: "Interview Invitation",
      message:
        "You have been invited for an interview. Check your email for details.",
      date: "07 April, 2021",
      time: "09:00 AM",
    },
    {
      title: "Application Status Update",
      message:
        "Your application status has been updated. Visit 'Applied Jobs' for details.",
      date: "08 April, 2021",
      time: "03:45 PM",
    },
  ];

  const handleFilterType = (type = "") => {
    console.log(type);
  };

  const handlePaginationSize = (pgNo) => {
    let max = pgNo * 10;
    let min = max - 10 >= 0 ? max - 10 : 0;
    setClipArrLength({ min: min, max: max });
    // getAllJobPost(pgNo)
    setActivePageNo(pgNo);
  };

  const handleIncPagination = () => {
    setpaginationBtnArr(paginationBtnArr.map((item, _) => item + 1));
    // if(totalPage < paginationBtnArr[4]){
    // getAllJobPost(paginationBtnArr[4]+1)
    setActivePageNo(paginationBtnArr[4] + 1);
    // }else{
    // getAllJobPost(totalPage)
    // }
  };
  const handleDecPagination = () => {
    if (paginationBtnArr[0] > 1) {
      setpaginationBtnArr(paginationBtnArr.map((item, _) => item - 1));
      // getAllJobPost(paginationBtnArr[0]-1);
      setActivePageNo(paginationBtnArr[0] - 1);
    } else {
      // getAllJobPost(paginationBtnArr[0]);
      setActivePageNo(paginationBtnArr[0]);
    }
  };

  const markAllAsRead = () => {
    setLoader(true);
    axios
      .patch(
        `${COMPANY_URLS?.readAllNotifications}`,
        { status: "read" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        getAllNotification();
        return res;
      })
      .catch((err) => console.error(err))
      .finally(() => setLoader(false));
  };

  const deleteNotificationById = (id) => {
    axios
      .delete(`${COMPANY_URLS.deleteNotificationById}/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        // successPopup(res?.data?.message);
        getAllNotification(10, 1);
      })
      .catch((err) => {
        errorPopup(err?.response?.data?.message);
      });
  };

  const getAllNotification = async (limit = null, page = null) => {
    try {
      const response = await axios.get(`${COMPANY_URLS.getNotification}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          limit,
          page,
        },
      });
      setAllNotifications(response?.data?.data);
      setTotalPage(response?.data?.data?.notification?.totalResults);
      return response?.data?.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const deleteAllNotification = () => {
    axios
      .delete(`${COMPANY_URLS.deleteAllNotification}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        successPopup(res?.data?.message);
        getAllNotification();
      })
      .catch((err) => {
        errorPopup(err?.response?.data?.message);
      });
  };

  const handleFormateDate = (dateStr = "2024-12-17T05:08:32.055Z") => {
    let date = new Date(dateStr);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    const timeFormated = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedDate} | ${timeFormated}`;
  };

  useEffect(() => {
    getAllNotification();
  }, []);

  return (
    <>
      <h1 className="notication_title mt-3 mb-1">Notification</h1>
      <div className="notification-main">
        <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
          <div className="d-none d-lg-block">
            <div className="notification-filterbtns d-flex gap-1 flex-md-row flex-column flex-wrap justify-content-between">
              <div
                onClick={() => handleFilterBtnChange("all")}
                className={`${filterBtn.all && "active-notifi-filterBtn"}`}
              >
                All
              </div>
              <div
                onClick={() => handleFilterBtnChange("newApplication")}
                className={`${
                  filterBtn.newApplication && "active-notifi-filterBtn"
                }`}
              >
                New Application
              </div>
              <div
                onClick={() => handleFilterBtnChange("jobUpdates")}
                className={`${
                  filterBtn.jobUpdates && "active-notifi-filterBtn"
                }`}
              >
                Job Updates
              </div>
              <div
                onClick={() => handleFilterBtnChange("accountUpdates")}
                className={`${
                  filterBtn.accountUpdates && "active-notifi-filterBtn"
                }`}
              >
                Account Updates
              </div>
            </div>
          </div>
          <DropdownButton
            id="dropdown-basic-button"
            className="d-block d-lg-none responsiveMenu mb-2"
            title="Dropdown button"
          >
            <Dropdown.Item onClick={() => handleFilterType("all")}>
              All
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleFilterType("new application")}>
              New Application
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleFilterType("Job Updated")}>
              Job Updates
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleFilterType("Account Updates")}>
              Account Updates
            </Dropdown.Item>
          </DropdownButton>
          <div className="notification_action_btns d-flex justify-content-between flex-wrap gap-2 gap-sm-4">
            <button onClick={() => markAllAsRead()}>
              {loader ? (
                <span
                  style={{
                    width: "20px",
                    display: "inline-block",
                    marginRight: "5px",
                  }}
                >
                  <Oval width={20} height={18} />
                </span>
              ) : (
                <img src={multipleMarkedIcon} alt="multipleMarkedIcon" />
              )}
              Marked All as Read
            </button>
            <button onClick={deleteAllNotification}>
              <MdDelete fontSize={24} /> Remove All
            </button>
          </div>
        </div>
        <div className="notification_items_list mt-4">
          {allNotifications?.notifications?.results?.map((notifi, idx) => (
            <div
              key={idx}
              className={`d-flex justify-content-between align-items-center gap-2 mb-2 ${
                notifi?.status === "unread" ? "unread_bgc" : ""
              }`}
            >
              <div className="notication-list mb-3">
                <p>{notifi.notificationTitle}</p>
                <p>{notifi?.notificationBody}</p>
                <p>{handleFormateDate(notifi?.createdAt)}</p>
              </div>
              <div
                onClick={() => deleteNotificationById(notifi?._id)}
                className="delete_wrapper"
              >
                <MdDelete fontSize={24} />
              </div>
            </div>
          ))}
        </div>
        {/* <div className="footer-pagination d-flex align-items-center justify-content-center pb-3">
                    <div className='d-flex align-items-center gap-2'>
                        <PaginationBtn
                            disabled={paginationBtnArr[0] === 1}
                            className={`pagination-btn ${(paginationBtnArr[paginationBtnArr?.length - 1] / 10 < 1) && 'shadow-none'} `}
                            onClick={handleDecPagination}>
                            <FaAngleLeft fontSize={20} />
                            Previous
                        </PaginationBtn>
                        {
                            paginationBtnArr.map((data, idx) => (
                                <PaginationBtn
                                    key={idx}
                                    onClick={() => handlePaginationSize(data)}
                                    className={`pagination-btn ${(activePageNo === data && 'pagination-active')} 
                                    `}
                                >
                                    {data}
                                </PaginationBtn>
                            ))
                        }
                        <PaginationBtn
                            disabled={totalPage < paginationBtnArr[4]}
                            className={`pagination-btn`} onClick={handleIncPagination}>
                            Next
                            <FaAngleRight fontSize={20} />
                        </PaginationBtn>    
                    </div>
                </div> */}
        <div className="view_option d-flex flex-column align-items-center">
          {totalPage > notificationRange?.limit ? (
            <span
              onClick={() => {
                getAllNotification(notificationRange?.limit + 50, 1);
                setNotificationRange((prev) => ({
                  ...prev,
                  limit: prev.limit + 50,
                  status: false,
                }));
              }}
            >
              View more...
            </span>
          ) : (
            <>
              {notificationRange?.limit > 100 && (
                <span
                  onClick={() => {
                    getAllNotification(100, 1);
                    setNotificationRange((prev) => ({ ...prev, status: true }));
                  }}
                >
                  Show Less
                </span>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
